/** @module Camunda/TaskDefinitionCustomViewRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"csi/html",
	"csi/locale",
	"csi/prefs",
	"./_TaskSetupMixin"
], function(declare,Ref,html,locale,csiPrefs,_TaskSetupMixin) {
	
	return declare([Ref, _TaskSetupMixin], {
		/**
		 * @override
		 * If default custom view is chosen, then display it
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			const res = this.inherited(arguments);
			
			if (!res && ctx.getNode().ViewStoreId) {
				const text = this._taskSupportsCustomViews(ctx) ? csiPrefs.getDefaultViewName() : locale.resource("NotApplicable");
				html.text(refNode, text);
				return true;
			}
			
			return false;
		}
	});
});